import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './loading.component.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

export type HolderProps = {
    /**
     * Replace holder class name with wrapper class name
     * */
    isWrapper?: boolean,

    /**
     * Inline height style
     * */
    height?: number,

    /**
     * Custom classes
     * @deprecated It will be removed in 6 months 09-20-2025. use className instead
     */
    mix?: string,

    /**
     * LoadingHolder children
     * */
    children: ReactNode,

    /**
     * ClassName for the component
     */
    className?: string,
};

/**
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/story/components-loading-loading}
 */
export function LoadingHolder(props: HolderProps) {
    const {
        isWrapper = false,
        height,
        mix,
        className,
        children,
    } = props;
    const loadingClasses = classNames(mix, className, {
        'loading-holder': !isWrapper,
        'loading-wrapper': isWrapper,
    });
    return (
        <span
            className={loadingClasses}

            style={
                height
                    ? {
                            height: `${height}px`,
                        }
                    : undefined
            }>
            {children}
        </span>
    );
}
